import { API_RESERVE, type ReserveBookingResponse } from "@/shared/server";
import { createDate } from "@/utils";
import { getDefaultParameters } from "@/utils/getDefaultParameters";
import { useMutation } from "@tanstack/react-query";
import dayjs from "dayjs";

export const useBookParameter = () => {
    const hostName = window.location.hostname;
    const mutation = useMutation({
        mutationFn: API_RESERVE.getReserveRoomInfo<ReserveBookingResponse>,
        onSuccess: (data) => {
            if (data.uid !== "" && hostName.includes("marginauto")) {
                const { currentObj } = createDate();
                const timeStamp = dayjs(currentObj).valueOf();
                const { idx, co_id } = getDefaultParameters();
                const { uid } = data;

                window
                    .open(
                        `https://calendar.marginauto.kr/payment?idx=${idx}&co_id=${co_id}&uid=${uid}&t=${timeStamp}`,
                        "_blank",
                    )
                    ?.focus();
            }
        },
    });

    return mutation;
};
